import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var AnimationWrapper = function AnimationWrapper(_ref) {
  var children = _ref.children,
    isVisible = _ref.isVisible,
    keyRender = _ref.keyRender;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: {
      enter: cx('animate_enter'),
      enterActive: cx('animate_entering'),
      enterDone: cx('animate_entered'),
      exit: cx('animate_exit'),
      exitActive: cx('animate_exiting'),
      exitDone: cx('animate_exited')
    },
    in: isVisible,
    key: keyRender,
    timeout: 100,
    unmountOnExit: true
  }, children);
};